export { GET_CONTENT_COLLECTIONS, GET_WATCH_COLLECTION_CONTENT } from './queries'
export { getContentCollections, getWatchCollectionContent } from './CollectionsService'
export type {
  ContentCollections,
  ContentCollection,
  ContentCollectionEdge,
  WatchCollectionContents,
  WatchCollectionContent,
  WatchCollectionEdge,
  WatchCollectionItem,
} from './types'
